import Layers from "slotworks/graphics/layers/layers";
import AbstractRadioControl from "slotworks/smart-ui/controls/abstract/abstract-radio-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class SingleWinLimitRadioControl extends AbstractRadioControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.radioGroup.formatFunction = formatMoneyAsCurrency;
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        this.updateValues(options.singleWinLimit.values, options.singleWinLimit.currentValue);
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.singleWinLimit.currentValue = value;
        options.customLossLimitSelected = false;

        this.onChange.dispatch(options);
    }
}
